function comments(elem) {
    var treincontent = 
    `           <div class="icon space"><img src="img/moon.svg" alt=""></div>
                <span class="bolder">Night train available</span> (on the entire route or partially)<br><br>
                * Train times from Leiden Central are based on the fastest train time. 
                Train journeys with transfer times of less than 5 minutes have been 
                filtered out here.
    `;

    var buscontent =
    `       <div class="icon space"><img src="img/tram.svg" alt=""></div>
             <span class="bolder">Including train and / or bus</span><br><br>
            ** Flight times include travel to the airport, time for check-in and customs, 
             and travel to the center from the airport in the destination country. For 
            this reason, 3 hours has been added to the total flight time.

    `

    var trein = document.createElement('div');
    trein.className = 'trein';
    trein.id = 'trein';
    trein.innerHTML += treincontent;
    elem.appendChild(trein);

    var bus = document.createElement('div');
    bus.className = 'bus';
    bus.id = 'bus';
    bus.innerHTML += buscontent;
    elem.appendChild(bus);
    
}